import React from 'react';
import VehicleForm from './VehicleForm.js';
import {useParams} from "react-router-dom"

export default function AddVehicleForGroup() {
  const { id } = useParams();
  return <VehicleForm groupId={Number(id)}/>;
}
